import React from "react";

function CalendarIcon({ className }: { className: string }) {
  return (
    <svg className={className} viewBox="0 0 21.265 21.265">
      <path
        d="M21.187,67.789a1.309,1.309,0,0,0-1.251-.919H18.607v2.015a1.994,1.994,0,0,1-3.987,0V66.87H6.639v2.015a1.994,1.994,0,0,1-3.987,0V66.87H1.329a1.308,1.308,0,0,0-1.251.919H0V83.611a1.314,1.314,0,0,0,1.329,1.3H19.936a1.314,1.314,0,0,0,1.329-1.3V67.789ZM19.936,83.611H1.329V73.226H19.936Z"
        transform="translate(0 -63.644)"
      />
      <path
        d="M95.956,6.372a.767.767,0,0,0,.767-.767V.767a.767.767,0,0,0-1.533,0V5.605A.767.767,0,0,0,95.956,6.372Z"
        transform="translate(-91.249)"
      />
      <path
        d="M382.157,6.372a.768.768,0,0,0,.767-.767V.767a.767.767,0,0,0-1.533,0V5.605A.768.768,0,0,0,382.157,6.372Z"
        transform="translate(-365.605)"
      />
    </svg>
  );
}

export { CalendarIcon };
